import ReactModal from "react-modal";
import "../../../components/modal/ModalCss.scss";
import BasicButton from "components/button/BasicButton";
import { sendPost } from "api/restUtil";
import { useEffect, useState } from "react";
import BasicInput from "components/input/BasicInput";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import { getResultMsg } from "js/order";
import Float from "components/input/Float";

/**
 * 취소 요청 팝업
 */
function OrderCancelReqModal (props) {

	const { isOpen, onClose, modalId, initData } = props;
	const [data, setData] = useState({});	// 취소 요청 정보

	const popupDivId = "orderCancelPopup";

	useEffect(() => {
		if(isOpen && initData) {
			setData({...initData});
		};

	}, [isOpen, initData])

	// 정보 변경
	const handleDataChange = (e) => {
		const {name, value} = e.target;
		// let d = {...data};
		// d[name] = value;

		setData(prev => ({...prev, [name]: value}));
	}

	// 취소 요청 처리
	const productOrderCancelRequest = async () => {
		const preSelector = "#" + popupDivId;
		const requiredColumns = ["cancelReason"];
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, preSelector)) return;

		const param = {...data};

		if(!window.confirm("취소 하시겠습니까?")) return;

		const result = await sendPost("/api/order/claim/cancel/req", param);
		if(result.respCode === "SUCCESS") {
			if(result.data.data.successProductOrderIds.length > 0) {
				alert("취소 되었습니다.");
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
			
			onClose(result.data.data.successProductOrderIds.length, result.data.data.failProductOrderInfos.length);
		}
	}
	
	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#" + popupDivId);
	}, [data]);


	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={"상품주문 취소 요청 팝업"}
			id={modalId}
		>
			<div className="me-modal" id={popupDivId}>
				<div className="me-modal-container" style={{width: "500px", height: "450px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">상품주문 취소</h4>
						</div>
						<div className="me-modal-body" style={{overflowY: "auto", overflowX: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="grid-table" style={{gridTemplateColumns: "1fr 3fr"}}>
								
								<div className="th required">취소 사유</div>
								<div className="td">
									<CommonCodeSelect
										item={{col: "cancelReason"}} 
										onChange={handleDataChange} 
										value={data?.cancelReason || ""} 
										defaultLabel="선택" 
										grpCd="CANCEL_REASON" 
										// width={100} 
									/>
								</div>

								<div className="th">취소 상세 사유</div>
								<div className="td">
									<BasicInput item={{col: "cancelDetailedReason"}} value={data?.cancelDetailedReason} onChange={handleDataChange} width="" textAlign="left" />
								</div>

								{/* <div className="th">취소 수량</div>
								<div className="td">
									<Float className="basic-input" name={"cancelQuantity"} value={data?.cancelQuantity ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={1} />
								</div> */}
							</div>
						</div>
						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={() => onClose(null)} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={() => productOrderCancelRequest()} style={{width: "100%"}} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default OrderCancelReqModal;
